import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, Row, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App.js';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email.js';
import HomePage from '../domain/HomePage.js';
import InstagramId from '../domain/InstagramId.js';
import Password from '../domain/Password.js';
import ProfileImage from '../domain/ProfileImage.js';
import SelfIntroduction from '../domain/SelfIntroduction.js';
import Sex from '../domain/Sex.js';
import TwitterId from '../domain/TwitterId.js';
import UserId from '../domain/UserId.js';
import UserInfo from '../domain/UserInfo.ts';
import AiWorksDisplayFlag from '../domain/R18DisplayFlag.js'
import UserName from '../domain/UserName.js';
import * as ImageUtil from '../service/ImageUtil.js';
import ApiFetch from './ApiFetch.js';
import Dialog from './Dialog.js';
import Footer from './Footer.js';
import Header from './Header.js';
import OnetimePassword from '../domain/OnetimePassword.js';
import CampaignMessage from './CampaignMessage.js';
import Category from './Category.js';
import R18DisplayFlag from '../domain/R18DisplayFlag.js';
import R18GDisplayFlag from '../domain/R18GDisplayFlag.js';
import DisplayId from '../domain/DisplayId.js';
import GitHubId from '../domain/GitHubId.js';
import HuggingFaceId from '../domain/HuggingFaceId.js';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService.js';
import SexualExpressionDisplayFlag from '../domain/PG12DisplayFlag.js';
import Language from '../domain/Language.js';
import * as Icon from 'react-bootstrap-icons';
import Thumb from './common/Thumb.js';
import Cropper from 'react-easy-crop';

const SeriesEditPopup = (props) => {
    async function getUserInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // seriesIdがあれば更新、なければ新規
    async function update(seriesId,seriesName,seriesLink,seriesDescription,seriesAgeLimit,seriesImage,seriesDetail,dialog){
        // 必須・文字数・パターン
        if(seriesName.length > 100){
            dialog(t("common.error"),"シリーズ名は100文字までにしてください。")
            return
        }
        if(seriesLink.length > 200){
            dialog(t("common.error"),"リンクは200文字までにしてください。")
            return
        }
        if(seriesDescription.length > 2000){
            dialog(t("common.error"),"シリーズ概要は2000文字までにしてください。")
            return
        }
        if(seriesImage === ""){
            dialog(t("common.error"),"サムネイルを設定してください。")
            return
        }
        if(seriesDetail.length === 0){
            dialog(t("common.error"),"シリーズには1件以上追加してください。")
            return
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/",
            {seriesId:seriesId,seriesName:seriesName,seriesLink:seriesLink,seriesDescription:seriesDescription,
                seriesAgeLimit:seriesAgeLimit,seriesImage:seriesImage,seriesDetail}).then((r)=>{
            return r.json().then((json)=>{
                return json
            })
        })
    }
    async function getImage(page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/my/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getSeriesInfo(seriesId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/infoById/"+seriesId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate();

    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false)
    const [seriesImage, setSeriesImage] = useState("")
    const [srcImage, setSrcImage] = useState("")

    const [imageList,setImageList] = useState([])
    const [imagePage,setImagePage] = useState(1)
    const [seriesInfo,setSeriesInfo] = useState([])
    const [seriesDetail,setSeriesDetail] = useState([])
    const [seriesId,setSeriesId] = useState(props.seriesId)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // フラグ：AI生成作品を表示する
    const [sexualExpressionValue, setSexualExpressionValue] = useState('2');// 性的表現(軽微)
    const [r18Value, setR18Value] = useState('2');
    const [r18GValue, setR18GValue] = useState('2');
    const [userInfo, setUserInfo] = useState([]);
    const [userSetting, setUserSetting] = useState([]);
    const [ageLimit, setAgeLimit] = useState(1);
    const [language, setLanguage] = useState(1);

    // 初期処理
    useEffect(() => {
        // タイトル設定
        //document.querySelector("title").textContent = t("category.setting") + " - アワートAI"
        getUserInfo().then(r=>{
            setUserInfo(r)
        })
        getUserSetting().then(r=>{
            setUserSetting(r)
            setSexualExpressionValue(String(r.data.sexual_expression_display_flag))
            setR18Value(String(r.data.r18_display_flag))
            setR18GValue(String(r.data.r18g_display_flag))
            setLanguage(String(r.data.language))
        })
        // ログイン状況の確認後に取得
        if(loginInfo.length !== 0)
        getImage(imagePage).then(r => {
            if(r.result){
                if(r.data.length > 0){
                    setImageList([].concat(r.data))
                } else {
                    if(imagePage === 1){
                        setImageList([])
                    }
                }
            } else {
                setImageList([])
                dialog(t("common.confirm"),r.errors)
            }
        })
        if(seriesId !== undefined){
            // 既存のデータを編集するモード
            getSeriesInfo(seriesId).then(r => {
                if(r.result){
                    setSeriesInfo(r.data.info)
                    setAgeLimit(String(r.data.info.series_age_limit))
                    setSeriesDetail(r.data.detail)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
    },[imagePage])

    useEffect(() => {
        // 画像が設定されている場合
        if(seriesImage.startsWith("data:image/jpeg")){
            console.log("読み込み完了")
        }
    },[seriesImage])

    // ログイン情報が取得出来たらプロフィール画像に設定
    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    useEffect(() => {
        if(seriesInfo.series_id !== undefined)
        setSeriesImage("//"+ApiFetch.IMG_HOST+"/series/"+seriesInfo.series_id+".webp?"+seriesInfo.update_datetime)
    },[seriesInfo])

    document.onkeydown = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
    }
    // シリーズ一覧に画像を追加する
    function imageAdd(info){
        if(seriesDetail.filter(d => d.group_id === info.group_id).length === 0){
            setSeriesDetail(seriesDetail.concat(info))
            dialog(t("common.confirm"),
            <Container style={{margin:"0 auto"}}>
                <Container className='text-center'>{t("common.added")}</Container>
                <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                    <Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/post/t/'+(info.group_id)+"_in"+ApiFetch.API_THUMB_EXT}
                    style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",borderRadius:"20px"}} className="p-2" />
                </Container>
                <Container style={{fontWeight:"bold",fontSize:"15px"}} className='text-center'>{info.title}</Container>
            </Container>)
        }
    }
    // シリーズ一覧から画像を削除する
    function imageDelete(info){
        setSeriesDetail(seriesDetail.filter(d => d.group_id !== info.group_id))
        dialog(t("common.confirm"),
        <Container style={{margin:"0 auto"}}>
            <Container className='text-center'>{t("common.removed")}</Container>
            <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                <Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/post/t/'+(info.group_id)+"_in"+ApiFetch.API_THUMB_EXT}
                style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",borderRadius:"20px"}} className="p-2" />
            </Container>
            <Container style={{fontWeight:"bold",fontSize:"15px"}} className='text-center'>{info.title}</Container>
        </Container>)
    }

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const [tempThumbnail,setTempThumbnail] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])

    return (
        <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",zIndex:4}}>
        <div id="series-edit-popup" style={{position:"fixed",top:"1%",left:"1%",width:"98%",height:"98%",zIndex:5,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
        <Button variant='secondary' className='m-3' style={{position:"fixed",left:"14px",zIndex:1}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Container className='d-flex flex-row justify-content-center flex-wrap' style={{marginTop:"60px"}}>
        <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                <Container>
                    <h3>{t("common.series")}</h3>
                    <Container style={{textAlign:"center"}}>
                        {seriesImage === "" ? (
                            <div className='mb-3' onClick={(e) => document.getElementById("file").click()}>
                                <Container style={{width:"400px",height:"200px",paddingTop:"80px",border:"1px solid #000000",cursor:"pointer"}}>
                                    2:1
                                </Container>
                            </div>
                        ) : (
                            <div className='mb-3' onClick={(e) => document.getElementById("file").click()}>
                                <Image src={seriesImage} style={{width:"400px",height:"200px",marginRight:"30px",cursor:"pointer"}} />
                            </div>
                        )}
                        <Image src={srcImage} id="load-image" style={{display:"none"}} />
                        <Button onClick={(e) => document.getElementById("file").click()}>{t("common.selectThumbnail")}</Button><br /><br />
                        <Form.Control type="file" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => {
                            setShowCropper(true)
                            ImageUtil.loadImageBig(e.currentTarget.files,setSrcImage,false)
                            document.getElementById("file").value = ""
                        }} />
                    </Container>
                    {showCropper ? (
                        <Container>
                    <Cropper
                        classes={{containerClassName: "cropper-container"}}
                        image={srcImage}
                        crop={crop}
                        zoom={zoom}
                        aspect={2 / 1}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}

                    />
                        <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"20px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setSeriesImage(tempThumbnail)
                                setShowCropper(false)
                            }}>OK</Button>
                            <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                            </Container>
                        </Container>
                    ) : ""}
                    <FloatingLabel controlId="series-name" label={t("series.name")} className="mb-3">
                        <Form.Control type="text" defaultValue={seriesInfo.series_name} />
                    </FloatingLabel>
                    https://ourt-ai.work/series/{loginInfo.displayId.length > 0 ? loginInfo.displayId : loginInfo.userId}/(リンク文字列)
                    <FloatingLabel controlId="series-link" label={t("series.link")} className="mb-3">
                        <Form.Control type="text" defaultValue={seriesInfo.series_link} />
                    </FloatingLabel>
                    <FloatingLabel controlId="series-description" label={t("series.description")} style={{lineHeight:"20px"}}
                        onInput={(e) =>{
                            let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                            let n = e.nativeEvent.target.value.match(/\n/g)
                            if(n === null){
                                n = 1
                            } else {
                                n = n.length + 1
                            }
                            if(n <= 5){
                                n = 5
                            }
                            e.currentTarget.style.height = lineHeight * n + 30 + "px"
                            document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                        }}>
                        <Form.Control
                            className='textarea'
                            as="textarea"
                            style={{ height: '100px' }}
                            defaultValue={seriesInfo.series_description}
                        />
                    </FloatingLabel>

                    <p className='d-inline '>{t("upload.image.ageLimit")}</p>
                    <Form.Select id="series-age-limit" className="mb-3" value={ageLimit} onChange={(e) => setAgeLimit(e.target.value)}>
                        <option value="1">{t("common.allAges")}</option>
                        <option value="2">PG-12</option>
                        <option value="3">R-15</option>
                        <option value="4">R-18</option>
                        <option value="5">R-18G</option>
                    </Form.Select>

                    <Button className="mt-3 mb-3" onClick={() => update(
                    seriesId,
                    document.getElementById("series-name").value,
                    document.getElementById("series-link").value,
                    document.getElementById("series-description").value,
                    document.getElementById("series-age-limit").value,
                    seriesImage,
                    seriesDetail,
                    dialog
                    ).then((r)=>{
                        if(r.result){
                            dialog(t("common.confirm"),"更新しました。")
                            props.onUpdate(r.data.seriesId)
                            setSeriesId(r.data.seriesId)
                        } else {
                            dialog(t("common.error"),r.errors)
                        }
                    })}>{t("common.update")}</Button>
                </Container>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mb-3" style={{margin:"0 auto",border:"1px solid #555555"}}>
                    <h3>投稿一覧</h3>
                    <Container className='d-flex flex-row justify-content-start flex-wrap'>
                        {imageList.map((data,i) => {
                            return <Thumb data={data} i={i} dialog={dialog} key={i}
                                onAddPress={imageAdd}
                                userInfoHidden={true}
                                />
                        })}
                    </Container>
                    <Container className='d-flex justify-content-between mb-3' style={{width:"200px"}}>
                        {imagePage > 1 ? (
                                <Button onClick={() => {
                                    setImagePage(imagePage-1)
                                } }>{t("common.prev")}</Button>
                            ) : <Button disabled>{t("common.prev")}</Button>}
                        {imageList.length > 30 ? (
                                <Button onClick={() => {
                                    setImagePage(imagePage+1)
                                } }>{t("common.next")}</Button>
                            ) : <Button disabled>{t("common.next")}</Button>}
                    </Container>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                    <Button className="mt-3 mb-3" onClick={() => update(
                    seriesId,
                    document.getElementById("series-name").value,
                    document.getElementById("series-link").value,
                    document.getElementById("series-description").value,
                    document.getElementById("series-age-limit").value,
                    seriesImage,
                    seriesDetail,
                    dialog
                    ).then((r)=>{
                        if(r.result){
                            dialog(t("common.confirm"),"更新しました。")
                            props.onUpdate(r.data.seriesId)
                            setSeriesId(r.data.seriesId)
                        } else {
                            dialog(t("common.error"),r.errors)
                        }
                    })}>{t("common.update")}</Button>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",border:"1px solid #555555"}}>
                    <h3>シリーズに追加済み</h3>
                    <Container className='d-flex flex-row justify-content-start flex-wrap'>
                        {seriesDetail.map((data,i) => {
                            return <Thumb data={data} i={i} dialog={dialog} key={i}
                                userInfoHidden={true}
                                onDeletePress={imageDelete}
                                />
                        })}
                    </Container>
                </Col>
            </Row>
        </Container>
        </div>
        </div>
    )
}

export default SeriesEditPopup;
